import React from "react";

import {
  formatFuelIntervalRate,
  formatHaPerHour,
} from "./fuelSupplyMetrics";

import "./FuelSupplySummary.css";

function MetricCell({ label, litersPerHa, litersPerHour, haPerHour, t }) {
  return (
    <div className="fuel-supply-summary-cell">
      <span className="fuel-supply-summary-cell-label">{label}</span>
      <span className="fuel-supply-summary-cell-value">
        {formatFuelIntervalRate(litersPerHa, t("L/ha"))}
      </span>
      <span className="fuel-supply-summary-cell-value">
        {formatFuelIntervalRate(litersPerHour, t("L/h"))}
      </span>
      <span className="fuel-supply-summary-cell-value">
        {formatHaPerHour(haPerHour)}
      </span>
    </div>
  );
}

function SummaryGrid({ summary, t }) {
  if (!summary || !summary.intervalCount) return null;

  const { lastSupply, avgLast3, avgTotal } = summary;

  return (
    <div className="fuel-supply-summary-grid">
      <div className="fuel-supply-summary-row-labels">
        <span></span>
        <span>{t("L/ha")}</span>
        <span>{t("L/h")}</span>
        <span>{t("ha/h")}</span>
      </div>
      {lastSupply ? (
        <MetricCell
          label={t("Último abastecimento")}
          litersPerHa={lastSupply.litersPerHa}
          litersPerHour={lastSupply.litersPerHour}
          haPerHour={lastSupply.haPerHour}
          t={t}
        />
      ) : null}
      <MetricCell
        label={t("Média últimos 3")}
        litersPerHa={avgLast3.litersPerHa}
        litersPerHour={avgLast3.litersPerHour}
        haPerHour={avgLast3.haPerHour}
        t={t}
      />
      <MetricCell
        label={t("Média total do período")}
        litersPerHa={avgTotal.litersPerHa}
        litersPerHour={avgTotal.litersPerHour}
        haPerHour={avgTotal.haPerHour}
        t={t}
      />
    </div>
  );
}

export default function FuelSupplySummary({
  summary,
  groupedSummaries,
  t,
  showHaNote,
  compact,
}) {
  const hasMain = summary && summary.intervalCount > 0;
  const hasGrouped = groupedSummaries && groupedSummaries.length > 0;

  if (!hasMain && !hasGrouped) return null;

  return (
    <div className={`fuel-supply-summary${compact ? " fuel-supply-summary-compact" : ""}`}>
      {hasMain ? (
        <>
          <div className="fuel-supply-summary-header">
            <strong>{t("Médias de diesel por intervalo entre abastecimentos")}</strong>
            {showHaNote ? (
              <span className="fuel-supply-summary-note">
                {t(
                  "L/ha e ha/h usam área do período repartida pelas horas do horímetro."
                )}
              </span>
            ) : null}
          </div>
          <SummaryGrid summary={summary} t={t} />
        </>
      ) : null}

      {hasGrouped ? (
        <div className="fuel-supply-grouped-summaries">
          {groupedSummaries.map((group) => (
            <div key={group.key} className="fuel-supply-grouped-block">
              <div className="fuel-supply-grouped-title">
                <strong>{group.label}</strong>
                <span className="fuel-supply-grouped-meta">
                  {group.recordCount} {t("abast.")}
                  {group.summary && group.summary.intervalCount
                    ? ` · ${group.summary.intervalCount} ${t("intervalos")}`
                    : ""}
                </span>
              </div>
              <SummaryGrid summary={group.summary} t={t} />
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}

export { SummaryGrid };
